import { createListenerMiddleware, isAnyOf } from "@reduxjs/toolkit";
import { setLocale } from "../features/i18nSlice/i18n.slice";
import { RootState } from "./rootReducers";

export const localStorageListenerMiddleware = createListenerMiddleware();
localStorageListenerMiddleware.startListening({
  matcher: isAnyOf(setLocale),
  effect: (action, listenerApi) => 
    localStorage.setItem(
       "gepo_locale",
       (listenerApi.getState() as RootState).i18n.locale
    )
});